declare global {
  interface Window {
    __ENV?: Record<string, string | undefined>;
  }
}

/**
 * Reads a `NEXT_PUBLIC_*` variable at RUNTIME instead of build time.
 *
 * - On the server it reads from `process.env` directly (the value injected by
 *   the Helm chart `envs:` into the pod).
 * - On the client it reads from `window.__ENV`, populated by `<PublicEnvScript />`
 *   on every request.
 *
 * The dynamic `process.env[key]` access is intentional: Next.js only inlines
 * *static* `process.env.NEXT_PUBLIC_X` references at build time, so reading by a
 * computed key keeps the value dynamic and lets a single image be promoted
 * across environments.
 */
export function getPublicEnv(
  key: `NEXT_PUBLIC_${string}`,
  fallback?: string
): string | undefined {
  if (typeof window === "undefined") {
    return process.env[key] ?? fallback;
  }

  return window.__ENV?.[key] ?? fallback;
}
